module.exports = __webpack_public_path__ + "static/blog-21-56d4ef0f552c70f3482b7cb6910de0ac.png";